<template>
	<div class="home">
		<div class="home_con_1" :style="{ backgroundImage: `url(${bannerImage})` }">
			<div class="text-content">
				<h2>{{ $t('home.title') }}</h2>
				<h3>{{ $t('home.tips') }}</h3>
			</div>
		</div>
<!-- 		<div class="home_con_2">
			<ProductCenter />
		</div> -->
		<div class="home_con_3">
			<ProductCenter2 />
		</div>
		<div class="home_con_4">
			<Center3 />
		</div>
		<div class="home_con_5">
			<Center4 />
		</div>
		<div class="home_con_6">
			<Center5 />
		</div>
	</div>
</template>

<script>
import { bannerApi, baseImgUrl } from '../netTool/api';
import ProductCenter from '../components/home_product_1.vue';
import ProductCenter2 from '../components/home_product_2.vue';
import Center3 from '../components/home_3.vue';
import Center4 from '../components/home_4.vue';
import Center5 from '../components/home_5.vue';

export default {
	name: 'Home',
	components: {
		ProductCenter,
		ProductCenter2,
		Center3,
		Center4,
		Center5
	},
	data() {
		return {
			bannerImage: ''
		};
	},
	async mounted() {
		try {
			const navId = 1;
			const response = await bannerApi.getBanner(navId);
			if (response.success) {
				this.bannerImage = baseImgUrl + response.banner.image_url;
			}
		} catch (error) {}
	}
};
</script>

<style scoped>
.home {
	--base-width: 1920;
	--scale-factor: 2.5;

	width: 100%;
	overflow: hidden;
}

.home_con_1 {
	display: flex;
	align-items: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	aspect-ratio: 1920/922;
	position: relative;
}

.text-content {
	width: 50%;
	padding-left: 10%;
}

h2 {
	font-size: 128px;
	color: #fff;
	font-weight: bold;
	margin-bottom: 20px;
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

h3 {
	font-size: 48px;
	max-width: 75%;
	color: #ededed;
	line-height: 1.4;
	text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
	.text-content {
		width: 80%;
		padding-left: 5%;
	}

	h2 {
		font-size: 36px;
	}

	h3 {
		font-size: 18px;
	}
}

.home_con_2 {
	background-color: #f8f8f8;
}

.home_con_3 {
	background-color: #fff;
}

.home_con_4 {
	background-color: #ced2d5;
}

.home_con_5 {
	background-color: #f8f8f8;
}

.home_con_6 {
	background-color: #fff;
}
</style>
